import React, { useState } from 'react';
import { Button } from './ui/button';
import { Phone, Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { translate } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm border-b border-yellow-500/20">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center space-x-4">
            <img 
              src="/luxor_logo_inverted.png" 
              alt="Luxor Limousine" 
              className="h-12 w-auto"
            />
            <div className="text-sm text-white/80">
              <div className="font-semibold">LIMOUSINE SERVICE</div>
              <div className="text-xs text-yellow-400">Montreux</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-white/80 hover:text-yellow-400 transition-colors">
              {translate('services')}
            </a>
            <a href="#fleet" className="text-white/80 hover:text-yellow-400 transition-colors">
              {translate('fleet')}
            </a>
            <a href="#about" className="text-white/80 hover:text-yellow-400 transition-colors">
              {translate('about')}
            </a>
            <a href="#contact" className="text-white/80 hover:text-yellow-400 transition-colors">
              {translate('contact')}
            </a>
          </nav>

          {/* Contact Info, Language Selector & CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-white/80">
              <Phone size={16} />
              <span className="text-sm">+41 79 199 10 10</span>
            </div>
            <LanguageSelector />
            <Button className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
                    onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              {translate('bookNow')}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center space-x-2 md:hidden">
            <LanguageSelector />
            <button 
              className="text-white"
              onClick={toggleMenu}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-black/95 border-t border-yellow-500/20">
            <nav className="flex flex-col py-4 space-y-4">
              <a href="#services" className="text-white/80 hover:text-yellow-400 transition-colors px-4">
                {translate('services')}
              </a>
              <a href="#fleet" className="text-white/80 hover:text-yellow-400 transition-colors px-4">
                {translate('fleet')}
              </a>
              <a href="#about" className="text-white/80 hover:text-yellow-400 transition-colors px-4">
                {translate('about')}
              </a>
              <a href="#contact" className="text-white/80 hover:text-yellow-400 transition-colors px-4">
                {translate('contact')}
              </a>
              <div className="px-4 pt-4 border-t border-yellow-500/20">
                <div className="flex items-center space-x-2 text-white/80 mb-4">
                  <Phone size={16} />
                  <span className="text-sm">+41 79 199 10 10</span>
                </div>
                <Button className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
                        onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                  {translate('bookNow')}
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;